module.exports = __webpack_public_path__ + "static/media/ndis-introdcution-image.f08bd1f0.svg";